import { render } from "./doorBox.vue?vue&type=template&id=23613262&scoped=true"
import script from "./doorBox.vue?vue&type=script&lang=js"
export * from "./doorBox.vue?vue&type=script&lang=js"

import "./doorBox.vue?vue&type=style&index=0&id=23613262&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23613262"]])

export default __exports__